import { Context, useContext } from 'react';

/**
 * A generic hook for checking whether a used context is within a correct provider
 * */
const useContextNotUndefined = <
  T extends string | number | boolean | symbol | object,
>(
  context: Context<T | undefined>,
  useContextName?: string,
): T => {
  const contextToUse = useContext(context);

  if (contextToUse === undefined) {
    throw new TypeError(
      `${
        useContextName || 'useContextNotUndefined'
      } must be within correct Provider`,
    );
  }

  return contextToUse;
};

export default useContextNotUndefined;
